import { useCallback, useEffect, useState } from 'react'
import { getReportDescriptions } from '@/features/report-description/services/reportDescriptionService'
import type { ReportDescriptionMap } from '../types'

/**
 * Loads report descriptions for hub tooltips (Angular NgRx `reports` store parity).
 */
export function useReportDescriptionMap() {
  const [descriptions, setDescriptions] = useState<ReportDescriptionMap>({})
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const rows = await getReportDescriptions()
      const map: ReportDescriptionMap = {}
      for (const row of rows) {
        if (row.report_name) {
          map[row.report_name] = row.report_description ?? ''
        }
      }
      setDescriptions(map)
    } catch {
      setDescriptions({})
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void load()
  }, [load])

  const getTooltip = useCallback(
    (descriptionKey: string | undefined): string | undefined => {
      if (!descriptionKey) return undefined
      const text = descriptions[descriptionKey]
      return text?.trim() ? text : undefined
    },
    [descriptions],
  )

  return { descriptions, loading, getTooltip, reload: load }
}
